var map = {
	"./arrowdown.json": 5966,
	"./arrowleft.json": 6910,
	"./arrowright.json": 8527,
	"./arrowup.json": 6563,
	"./bgcut.json": 246,
	"./blackhole.json": 3918,
	"./blanksquare.json": 9301,
	"./canvas.json": 391,
	"./fillrect.json": 1778,
	"./home.json": 2777,
	"./levels.json": 1632,
	"./maintitle.json": 1386,
	"./mask.json": 7023,
	"./neutronstar.json": 1599,
	"./pointer.json": 8329,
	"./position.json": 5048,
	"./progress.json": 5346,
	"./puzzle.json": 3903,
	"./size.json": 5511,
	"./state.json": 9089,
	"./statemachine.json": 5854,
	"./text.json": 7292,
	"./tunnel.json": 8620,
	"./xsquare.json": 6270
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8256;